export const config = {
  apiUrl: "https://localhost:5001",
  //apiUrl: "https://hello-charlie-api-dev.azurewebsites.net",
  devApiUrl: "https://hello-charlie-api-dev.azurewebsites.net",
  prodApiUrl: "https://hello-charlie-api-prod.azurewebsites.net",

  supportTicketUrl: "https://elevated-demo-api.azurewebsites.net",

  authRoles: {
    sa: ["SA"], // Only Super Admin has access
    admin: ["SA", "Admin"], // Only SA & Admin has access
    editor: ["SA", "Admin", "Editor"], // Only SA & Admin & Editor has access
    user: ["SA", "Admin", "Editor", "User"], // Only SA & Admin & Editor & User has access
    guest: ["SA", "Admin", "Editor", "User", "Guest"], // Everyone has access
  },
  syncFusionLicense: "ORg4AjUWIQA/Gnt2VlhhQlJCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn9SdE1jW3xecXRQRWVa"
};
